import * as React from 'react'

const SvgTextUnderlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 16.25h15v1.25h-15v-1.25zm7.5-1.875A4.375 4.375 0 015.625 10V3.125h1.25V10a3.125 3.125 0 106.25 0V3.125h1.25V10A4.375 4.375 0 0110 14.375z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextUnderlineIcon
